import React, {useRef, forwardRef} from 'react';
import {Button, Icon} from 'components';
import {over, getElementAttributes, stopPropagation} from 'helpers';
import css from './button.module.scss';

export const Tag = forwardRef(({className, selected, ...props}, ref) =>
  <Button ref={ref} className={['tag', className]} pressed={selected} {...props} />
);

export function EditableTag({className, value, children, placeholder, clear, maxWidth = '10em', Suffix, ...props}) {
  const ref = useRef();
  const focus = () => ref.current.querySelector('input')?.focus();
  return (
    <div {...getElementAttributes(props)} className={css('editable-tag', className)} style={{'--max-width': maxWidth}} ref={ref} onClick={stopPropagation}>
      <span aria-hidden={Boolean(value)}>{ value || placeholder }</span>
      { children }
      { value && clear &&
        <Icon name="close" className={css.clear} onClick={over(clear, stopPropagation, focus)} />
      }
    </div>
  );
}
